import ChevronRightIcon from "@heroicons/react/16/solid/ChevronRightIcon";
import HomeIcon from "@heroicons/react/16/solid/HomeIcon";
import { ReactElement } from "react";

type BreadCrumbsProps = {
  includeHome?: boolean;
  pages: {
    current?: boolean;
    href?: string;
    name: string;
  }[];
};

const BreadCrumbs = ({
  includeHome = true,
  pages,
}: BreadCrumbsProps): ReactElement => {
  return (
    <nav aria-label="Breadcrumb" className="mb-4 flex">
      <ol className="flex items-center space-x-4" role="list">
        {includeHome && (
          <li>
            <div>
              <a className="text-gray-400 hover:text-gray-500" href="#">
                <HomeIcon aria-hidden="true" className="size-5 shrink-0" />
                <span className="sr-only">Home</span>
              </a>
            </div>
          </li>
        )}
        {pages.map((page) => (
          <li key={page.name}>
            <div className="flex items-center">
              <ChevronRightIcon
                aria-hidden="true"
                className="size-5 shrink-0 text-gray-400"
              />
              <a
                aria-current={page.current ? "page" : undefined}
                className="ml-4 text-sm font-medium text-gray-500 hover:text-gray-700"
                href={page.href}
              >
                {page.name}
              </a>
            </div>
          </li>
        ))}
      </ol>
    </nav>
  );
};

export default BreadCrumbs;
